export const certificarT1Steps = [
    {
        id: 'idiomas',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP1.WIZBT',
        videoBanner: 'idiomas',
        icon : 'language',
        ruta : './languages',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP1.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP1.SUBTI',
        status : 1,
        visible: true
    },
    {
        id: 'nps',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP_NPS.WIZBT',
        videoBanner: '',
        icon : 'face',
        ruta : './nps',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP_NPS.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP_NPS.SUBTI',
        status : 1,
        visible: true
    },
    {
        id: 'reactivos',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP1-1.WIZBT',
        videoBanner: 'reactivos',
        icon : 'sentiment_satisfied_alt',
        ruta : './reactives',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP1-1.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP1-1.SUBTI',
        status : 2,
        visible: true
    },
    {
        id: 'forall',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP2.WIZBT',
        videoBanner: 'forall',
        icon : 'format_list_numbered',
        ruta : './ForAll',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP2.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP2.SUBTI',
        status : 1,
        visible: true
    },
    {
        id: 'control',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP_CONTROL.TITULO',
        videoBanner: 'pregunta_control',
        icon : 'control_camera',
        ruta : './control',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP_CONTROL.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP_CONTROL.SUBTI',
        status : 1,
        visible: true
    },
    {
        id: 'demo',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP3.WIZBT',
        videoBanner: 'demograficos',
        icon : 'poll',
        ruta : './demographics',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP3.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP3.SUBTI',
        status : 1,
        visible: true
    },
    {
        id: 'abiertas',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP3-1.WIZBT',
        videoBanner: 'abiertas',
        icon : 'help_outline',
        ruta : './open',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP3-1.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP3-1.SUBTI',
        status : 2,
        visible: true
    },
    {
        id: 'adic',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP4.WIZBT',
        videoBanner: 'adicionales',
        icon : 'note_add',
        ruta : './additionals',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP4.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP4.SUBTI',
        status : 1,
        visible: true
    },
        {
        id: 'encues',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP4-1.WIZBT',
        videoBanner: 'crear_enc',
        icon : 'list_alt',
        ruta : './crearencuesta',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP4-1.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP4-1.SUBTI',
        status : 1,
        visible: true
    },
    {
        id: 'colabs',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP5.WIZBT',
        videoBanner: 'colaboradores',
        icon : 'people',
        ruta : './collaborators',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP5.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP5.SUBTI',
        status : 1,
        visible: true
    },
    {
        id: 'prog',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP6.WIZBT',
        videoBanner: 'programar',
        icon : 'date_range',
        ruta : './schedule',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP6.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP6.SUBTI',
        status : 1,
        visible: true
    },
    {
        id: 'envio',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP7.WIZBT',
        videoBanner: 'envio',
        icon : 'send',
        ruta : './mailSending',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP7.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP7.SUBTI',
        status : 1,
        visible: true
    },
    {
        id: 'confirmacion',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP9.WIZBT',
        videoBanner: '',
        icon : 'build_circle',
        ruta : './statusSurveys',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP9.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP9.SUBTI',
        status : 1,
        visible: true
    },
    {
        id: 'cierre',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP8.WIZBT',
        videoBanner: 'cierre',
        icon : 'trending_up',
        ruta : './close',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP8.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP8.SUBTI',
        status : 1,
        visible: true
    }
];

export let certificarIzzi = [
    {
        id: 'idiomas',
        title  : 'WIZARD.IZZI.STEPS.STP1.WIZBT',
        videoBanner: '',
        icon : 'language',
        ruta : './languages',
        tituloPagina: 'WIZARD.IZZI.STEPS.STP1.TITULO',
        subtiPagina: 'WIZARD.IZZI.STEPS.STP1.SUBTI',
        status : 1,
        visible: true
    },
    {
        id: 'nps',
        title  : 'WIZARD.IZZI.STEPS.STP_NPS.WIZBT',
        videoBanner: '',
        icon : 'face',
        ruta : './nps',
        tituloPagina: 'WIZARD.IZZI.STEPS.STP_NPS.TITULO',
        subtiPagina: 'WIZARD.IZZI.STEPS.STP_NPS.SUBTI',
        status : 1,
        visible: true
    },
    {
        id: 'reactivos',
        title  : 'WIZARD.IZZI.STEPS.STP1-1.WIZBT',
        videoBanner: '',
        icon : 'sentiment_satisfied_alt',
        ruta : './reactives',
        tituloPagina: 'WIZARD.IZZI.STEPS.STP1-1.TITULO',
        subtiPagina: 'WIZARD.IZZI.STEPS.STP1-1.SUBTI',
        status : 2,
        visible: true
    },
    {
        id: 'forall',
        title  : 'WIZARD.IZZI.STEPS.STP2.WIZBT',
        videoBanner: '',
        icon : 'format_list_numbered',
        ruta : './ForAll',
        tituloPagina: 'WIZARD.IZZI.STEPS.STP2.TITULO',
        subtiPagina: 'WIZARD.IZZI.STEPS.STP2.SUBTI',
        status : 1,
        visible: true
    },
    {
        id: 'control',
        title  : 'WIZARD.IZZI.STEPS.STP_CONTROL.TITULO',
        videoBanner: 'pregunta_control',
        icon : 'control_camera',
        ruta : './control',
        tituloPagina: 'WIZARD.IZZI.STEPS.STP_CONTROL.TITULO',
        subtiPagina: 'WIZARD.IZZI.STEPS.STP_CONTROL.SUBTI',
        status : 1,
        visible: true
    },
    {
        id: 'demo',
        title  : 'WIZARD.IZZI.STEPS.STP3.WIZBT',
        videoBanner: '',
        icon : 'poll',
        ruta : './demographics',
        tituloPagina: 'WIZARD.IZZI.STEPS.STP3.TITULO',
        subtiPagina: 'WIZARD.IZZI.STEPS.STP3.SUBTI',
        status : 1,
        visible: true
    },
    {
        id: 'abiertas',
        title  : 'WIZARD.IZZI.STEPS.STP3-1.WIZBT',
        videoBanner: '',
        icon : 'help_outline',
        ruta : './open',
        tituloPagina: 'WIZARD.IZZI.STEPS.STP3-1.TITULO',
        subtiPagina: 'WIZARD.IZZI.STEPS.STP3-1.SUBTI',
        status : 2,
        visible: true
    },
    {
        id: 'adic',
        title  : 'WIZARD.IZZI.STEPS.STP4.WIZBT',
        videoBanner: '',
        icon : 'note_add',
        ruta : './additionals',
        tituloPagina: 'WIZARD.IZZI.STEPS.STP4.TITULO',
        subtiPagina: 'WIZARD.IZZI.STEPS.STP4.SUBTI',
        status : 1,
        visible: true
    },
        {
        id: 'encues',
        title  : 'WIZARD.IZZI.STEPS.STP4-1.WIZBT',
        videoBanner: '',
        icon : 'list_alt',
        ruta : './crearencuesta',
        tituloPagina: 'WIZARD.IZZI.STEPS.STP4-1.TITULO',
        subtiPagina: 'WIZARD.IZZI.STEPS.STP4-1.SUBTI',
        status : 1,
        visible: true
    },
    {
        id: 'colabs',
        title  : 'WIZARD.IZZI.STEPS.STP5.WIZBT',
        videoBanner: '',
        icon : 'people',
        ruta : './collaborators',
        tituloPagina: 'WIZARD.IZZI.STEPS.STP5.TITULO',
        subtiPagina: 'WIZARD.IZZI.STEPS.STP5.SUBTI',
        status : 1,
        visible: true
    },
    {
        id: 'prog',
        title  : 'WIZARD.IZZI.STEPS.STP6.WIZBT',
        videoBanner: '',
        icon : 'date_range',
        ruta : './schedule',
        tituloPagina: 'WIZARD.IZZI.STEPS.STP6.TITULO',
        subtiPagina: 'WIZARD.IZZI.STEPS.STP6.SUBTI',
        status : 1,
        visible: true
    },
    {
        id: 'envio',
        title  : 'WIZARD.IZZI.STEPS.STP7.WIZBT',
        videoBanner: '',
        icon : 'send',
        ruta : './mailSending',
        tituloPagina: 'WIZARD.IZZI.STEPS.STP7.TITULO',
        subtiPagina: 'WIZARD.IZZI.STEPS.STP7.SUBTI',
        status : 1,
        visible: true
    },
    {
        id: 'cierre',
        title  : 'WIZARD.IZZI.STEPS.STP8.WIZBT',
        videoBanner: '',
        icon : 'trending_up',
        ruta : './close',
        tituloPagina: 'WIZARD.IZZI.STEPS.STP8.TITULO',
        subtiPagina: 'WIZARD.IZZI.STEPS.STP8.SUBTI',
        status : 1,
        visible: true
    }
];
